module.exports = __webpack_public_path__ + "img/2.cf182e91.png";